/* eslint-disable react/destructuring-assignment */
import { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'

import DateRangeCalendar from 'components/form/DateRangeCalendar'

const Wrapper = styled.div`
  padding-bottom: 24px;

  /* Breathe the calendar grid away from the prev/next nav + month
     caption row above it. Matches the host-availability surface. */
  .rdp-month_grid {
    margin-top: 10px;
  }
`

const DatesFilterInputs = ({ onChange, show, ...props }) => {
  const [values, setValues] = useState({
    startDate: props.startDate ? moment(props.startDate) : null,
    endDate: props.endDate ? moment(props.endDate) : null,
  })
  const { startDate, endDate } = values

  const handleDatesChange = (newStart, newEnd) => {
    const newDates = { startDate: newStart, endDate: newEnd }
    setValues(newDates)
    onChange(newDates)
  }

  useEffect(() => {
    setValues({
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null,
    })
  }, [props.startDate, props.endDate])

  if (!show) return null

  return (
    <Wrapper>
      <DateRangeCalendar
        daySize={40}
        startDate={startDate}
        endDate={endDate}
        onChange={handleDatesChange}
        numberOfMonths={1}
        minDate={moment()}
      />
    </Wrapper>
  )
}

export default DatesFilterInputs
